export { default as Payments } from './Payments'

export { SuccessView } from './SuccessView'
export { PaymentErrorSide } from './PaymentsErrorSide'